var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-ancestor is-parent" }, [
    _c("div", { staticClass: "tile is-parent" }, [
      _vm.entity
        ? _c("article", { staticClass: "tile is-child box" }, [
            _c("div", { staticClass: "columns is-gapless" }, [
              _c("div", { staticClass: "column" }, [
                _c("p", { staticClass: "title" }, [
                  _c("span", [_vm._v("Details")]),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.entity,
                          expression: "entity",
                        },
                      ],
                    },
                    [
                      _vm._v(
                        _vm._s(
                          ` - ${_vm.entity.prefix}${_vm.entity.quoteNo}${_vm.entity.suffix}`
                        )
                      ),
                    ]
                  ),
                ]),
                _vm.entity.orm
                  ? _c(
                      "div",
                      [
                        _c(
                          "div",
                          { staticClass: "field" },
                          [
                            _c(
                              "label",
                              { staticClass: "label", attrs: { for: "" } },
                              [_vm._v("Last Message No")]
                            ),
                            _c("vue-numeric", {
                              staticClass: "input",
                              attrs: { precision: 0 },
                              model: {
                                value: _vm.entity.orm.messageNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.entity.orm, "messageNo", $$v)
                                },
                                expression: "entity.orm.messageNo",
                              },
                            }),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "field" }, [
                          _c(
                            "label",
                            { staticClass: "label", attrs: { for: "" } },
                            [_vm._v("Quote Status")]
                          ),
                          _c("div", { staticClass: "select" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.entity.orm.quoteStatusId,
                                    expression: "entity.orm.quoteStatusId",
                                  },
                                ],
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.entity.orm,
                                      "quoteStatusId",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              _vm._l(_vm.quoteStatusTypes, function (type) {
                                return _c(
                                  "option",
                                  {
                                    key: type.value,
                                    domProps: { value: type.value },
                                  },
                                  [_vm._v(_vm._s(type.name))]
                                )
                              }),
                              0
                            ),
                          ]),
                        ]),
                        _c("div", {
                          staticClass: "is-divider",
                          attrs: { "data-content": "" },
                        }),
                        _c("div", { staticClass: "tabs" }, [
                          _c("ul", [
                            _c(
                              "li",
                              {
                                class: {
                                  "is-active":
                                    _vm.subComponent === "OrmQuoteItems",
                                },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        _vm.subComponent = "OrmQuoteItems"
                                      },
                                    },
                                  },
                                  [_vm._v("Items")]
                                ),
                              ]
                            ),
                            _c(
                              "li",
                              {
                                class: {
                                  "is-active":
                                    _vm.subComponent === "OrmQuoteImages",
                                },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        _vm.subComponent = "OrmQuoteImages"
                                      },
                                    },
                                  },
                                  [_vm._v("Images")]
                                ),
                              ]
                            ),
                            _c(
                              "li",
                              {
                                class: {
                                  "is-active":
                                    _vm.subComponent === "OrmQuoteRemarks",
                                },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        _vm.subComponent = "OrmQuoteRemarks"
                                      },
                                    },
                                  },
                                  [_vm._v("Remarks")]
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _c(_vm.subComponent, {
                          tag: "component",
                          model: {
                            value: _vm.entity,
                            callback: function ($$v) {
                              _vm.entity = $$v
                            },
                            expression: "entity",
                          },
                        }),
                      ],
                      1
                    )
                  : _c("div", { staticClass: "subtitle has-text-danger" }, [
                      _vm._v(" No ORM/PNET record "),
                    ]),
              ]),
            ]),
          ])
        : _c("article", { staticClass: "tile is-child box" }, [_vm._m(0)]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticClass: "title" }, [_vm._v(" Detail ")]),
      _c("p", { staticClass: "subtitle" }, [_vm._v("Please select a quote")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }